<h2>Change password</h2>

<div class="extend">
  <app-success-message [message]="successMessage"></app-success-message>
  <app-error-message [message]="errorMessage"></app-error-message>

  <form [formGroup]="changePwdForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label class="display-form">
        <span class="label-form">Current password</span>
        <div class="input-form">
          <input
            type="password"
            class="form-control"
            formControlName="currentPwd"
            placeholder="Current password"
            required
          />
          @if (currPwdError) {
            <i class="material-icons error-icon">error</i>
          }
          @if (currPwdError) {
            <div class="note error">{{ currPwdError }}</div>
          }
        </div>
      </label>
    </div>

    <div class="form-group">
      <label class="display-form">
        <span class="label-form">New password</span>
        <div class="input-form">
          <input
            type="password"
            class="form-control"
            formControlName="newPwd"
            placeholder="New password"
            required
          />

          @if (newPwdError) {
            <i class="material-icons error-icon">error</i>
          }
          <div class="note" [class.error]="newPwdError">
            {{ newPwdError || 'รหัสผ่านมีความยาวอย่างน้อย 6 ตัวอักษร' }}
          </div>
        </div>
      </label>
    </div>

    <div class="form-group">
      <label class="display-form">
        <span class="label-form">Confirm new password</span>
        <div class="input-form">
          <input
            type="password"
            class="form-control"
            formControlName="confirmNewPwd"
            placeholder="Confirm new password"
            required
          />

          @if (confirmNewPwdError) {
            <i class="material-icons error-icon">error</i>
          }
          @if (confirmNewPwdError) {
            <div class="note error">
              {{ confirmNewPwdError }}
            </div>
          }
        </div>
      </label>
    </div>

    <div class="form-bottom">
      <button mat-raised-button appThemedButton type="submit" class="submit" [disabled]="isLoading">
        Save changes
      </button>
    </div>
  </form>
</div>
